<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <app-content-header [contentHeader]="contentHeader"></app-content-header>
    <section class="row">
      <div class="col-lg-9 col-12">
        <ul class="mb-xl-0 nav nav-pills flex-row nav-left">
          <!--esperienze-->
          <li class="nav-item mb-1">
            <a [class]="'nav-link d-flex ' + (active_table === 'experience' ? 'active' : '')" (click)="proposedSkillCheck('experience')">
              <i [data-feather]="'award'" class="font-medium-3 mr-1"></i>
              <span class="font-weight-bold">{{ "EXPERIENCES" | translate }}</span>
            </a>
          </li>
          <!--skills-->
          <li class="nav-item mb-1">
            <a [class]="'nav-link d-flex ' + (active_table === 'skill' ? 'active' : '')" (click)="proposedSkillCheck('skill')">
              <i [data-feather]="'crosshair'" class="font-medium-3 mr-1"></i>
              <span class="font-weight-bold">{{ "SKILLS" | translate }}</span>
            </a>
          </li>
          <!--lingue-->
          <li class="nav-item mb-1">
            <a [class]="'nav-link d-flex ' + (active_table === 'language' ? 'active' : '')" (click)="proposedSkillCheck('language')">
              <i [data-feather]="'flag'" class="font-medium-3 mr-1"></i>
              <span class="font-weight-bold">{{ "LANGUAGES" | translate }}</span>
            </a>
          </li>
          <!--formazione-->
          <li class="nav-item mb-1">
            <a [class]="'nav-link d-flex ' + (active_table === 'education' ? 'active' : '')" (click)="proposedSkillCheck('education')">
              <i [data-feather]="'flag'" class="font-medium-3 mr-1"></i>
              <span class="font-weight-bold">{{ "EDUCATION_ONBOARDING" | translate }}</span>
            </a>
          </li>
        </ul>
      </div>
      <div class="col-lg-3 mb-1 col-12 text-right">
        <div ngbDropdown class="btn-group" *ngIf="currentUser && !is_my_profile">
          <button ngbDropdownToggle type="button" class="btn btn-outline-secondary" rippleEffect>{{ "EMPLOYEE_CV" | translate }}</button>
          <div ngbDropdownMenu>
            <a ngbDropdownItem has_capability="generate_branded_cv" (click)="_userService.generateCV(currentUser.hash)">{{ "GENERATE_BRANDED_CV" | translate }}</a>
            <a ngbDropdownItem has_capability="generate_branded_cv" (click)="_userService.generateCVWithData(currentUser.hash)">{{ "GENERATE_BRANDED_CV_WITH_DATA" | translate }}</a>
            <a ngbDropdownItem *ngIf="!!currentUser.candidate_cv_url" (click)="_utilService.getFile(currentUser.candidate_cv_url)">{{ "CV_AS_CANDIDATE" | translate }}</a>
          </div>
        </div>
      </div>
      <div class="col-12">
        <!-- esperienze -->
        <div class="card" *ngIf="active_table === 'experience'">
          <div class="card-body">
            <h3 class="mt-2">{{ "WORK" | translate }}</h3>
            <div class="row align-items-start border-bottom-1 border-bottom mb-2 pb-1" *ngFor="let exp of items_experiences; let i = index">
              <div class="col-lg-6">
                <div class="row">
                  <div class="col-lg-6 col-12 form-group">
                    <label [for]="'experience_from_' + i">{{ "FROM" | translate }}<sup class="text-danger">*</sup></label>
                    <input type="date" [id]="'experience_from_' + i" class="form-control" [(ngModel)]="exp.from" [readonly]="!_authenticationService.hasCapability('edit_other_user') && !this.is_my_profile" />
                  </div>
                  <div class="col-lg-6 col-12 form-group">
                    <label>{{ "TO_PERIOD" | translate }}<sup class="text-danger" *ngIf="!exp.isCurrentExperience">*</sup></label>
                    <input
                      [(ngModel)]="exp.to"
                      type="date"
                      [id]="'experience_to_' + i"
                      class="form-control"
                      [readonly]="!_authenticationService.hasCapability('edit_other_user') && !this.is_my_profile"
                      [min]="exp.from"
                      [disabled]="!exp.from || exp.isCurrentExperience"
                    />
                  </div>
                  <div class="col-lg-6 col-12 form-group mr-1">
                    <div class="d-flex align-items-center justify-content-between">
                      <label class="mb-0">{{ "IS_CURRENT_EXPERIENCE" | translate }}</label>
                      <div class="custom-control custom-control-primary custom-switch w-fit ml-1">
                        <input [id]="'is_current_experience' + i" type="checkbox" class="custom-control-input" [(ngModel)]="exp.isCurrentExperience" (change)="exp.to = null" />
                        <label class="custom-control-label" [for]="'is_current_experience' + i"></label>
                      </div>
                    </div>
                  </div>

                  <div class="col-lg-6 col-12 form-group">
                    <label [for]="'experience_agency_' + i">{{ "AGENCY_NAME" | translate }}<sup class="text-danger">*</sup></label>
                    <input type="text" [id]="'experience_agency_' + i" class="form-control" [(ngModel)]="exp.agency" [readonly]="!_authenticationService.hasCapability('edit_other_user') && !this.is_my_profile" />
                  </div>
                  <div class="col-lg-6 col-12 form-group">
                    <label [for]="'experience_customer_' + i">{{ "CUSTOMER" | translate }}</label>
                    <input type="text" [id]="'experience_customer_' + i" class="form-control" [(ngModel)]="exp.customer" [readonly]="!_authenticationService.hasCapability('edit_other_user') && !this.is_my_profile" />
                  </div>
                  <div class="col-lg-6 col-12 form-group">
                    <label [for]="'experience_domain_' + i">{{ "DOMAIN" | translate }}<sup class="text-danger">*</sup></label>
                    <ng-select
                      [id]="'experience_domain_' + i"
                      bindLabel="name"
                      bindValue="id"
                      [items]="_workDomainService.list"
                      [closeOnSelect]="true"
                      [clearable]="false"
                      [openOnEnter]="false"
                      [virtualScroll]="true"
                      [(ngModel)]="exp.domain"
                      [readonly]="!_authenticationService.hasCapability('edit_other_user') && !this.is_my_profile"
                    >
                    </ng-select>
                  </div>
                  <div class="col-lg-6 col-12 form-group">
                    <label [for]="'experience_figure_' + i">{{ "FIGURE" | translate }}<sup class="text-danger">*</sup></label>
                    <ng-select
                      bindValue="id"
                      bindLabel="name"
                      [id]="'experience_figure_' + i"
                      [(ngModel)]="exp.figure"
                      [closeOnSelect]="true"
                      [clearable]="false"
                      [openOnEnter]="false"
                      [virtualScroll]="true"
                      [items]="_userFigureService.list"
                      [readonly]="!_authenticationService.hasCapability('edit_other_user') && !this.is_my_profile"
                    ></ng-select>
                  </div>
                </div>
              </div>
              <div class="col-lg-6 col-xl-5">
                <div class="form-group">
                  <label [for]="'experience_tecnology_' + i">{{ "TECNOLOGIES" | translate }}<sup class="text-danger">*</sup></label>
                  <ng-select
                    bindValue="id"
                    bindLabel="name"
                    [id]="'experience_tecnology_' + i"
                    [(ngModel)]="exp.tecnologyApproved"
                    [items]="_skillService.list_enabled"
                    [multiple]="true"
                    [clearable]="false"
                    [openOnEnter]="false"
                    [virtualScroll]="true"
                    [readonly]="!_authenticationService.hasCapability('edit_other_user') && !this.is_my_profile"
                  ></ng-select>
                  <div class="form-group col-12 pl-0">
                    <p class="sugges-new-item" (click)="modalOpen(modalToProposeSkill, i)">{{ "MODAL.NOT_SKILL_CANDIDATE" | translate }}</p>
                  </div>
                  <div class="form-group col-12 pl-0 mb-0" *ngIf="skillToPropose[i] && skillToPropose[i].skill.length > 0">
                    {{ "SKILLS_TO_APPROVE" | translate }}: <span *ngFor="let item of skillToPropose[i].skill" class="badge badge-secondary ml-1 mb-025">{{ item }}</span>
                  </div>
                </div>
                <div class="form-group">
                  <label [for]="'experience_description_' + i">{{ "DESCRIPTION" | translate }}<sup class="text-danger">*</sup></label>
                  <textarea [id]="'experience_description_' + i" class="form-control" [(ngModel)]="exp.description" [readonly]="!_authenticationService.hasCapability('edit_other_user') && !this.is_my_profile"></textarea>
                </div>
              </div>
              <div class="col-lg-12 col-xl-1 text-right">
                <button
                  *ngIf="(items_experiences.length >= 1 && _authenticationService.hasCapability('edit_other_user')) || is_my_profile"
                  class="btn btn-icon btn-danger"
                  type="button"
                  (click)="removeExperienceItem(i)"
                  rippleEffect
                >
                  <span>{{ "REMOVE" | translate }}</span>
                </button>
              </div>
            </div>
            <button *ngIf="_authenticationService.hasCapability('edit_other_user') || is_my_profile" class="btn btn-icon btn-secondary" type="button" (click)="addExperienceItem()" rippleEffect>
              <i [data-feather]="'plus'" class="mr-25"></i>
              <span>{{ "ADD_NEW" | translate }}</span>
            </button>
          </div>
          <div class="card-footer d-flex justify-content-between" *ngIf="_authenticationService.hasCapability('edit_other_user') || is_my_profile">
            <div *ngIf="skillWaitingToApprove && skillWaitingToApprove.length > 0">
              {{ "SKILLS_TO_APPROVE" | translate }}: <span *ngFor="let item of skillWaitingToApprove" class="badge badge-secondary ml-1 mb-025">{{ item.name }}</span>
            </div>
            <button type="submit" class="btn btn-primary" (click)="save()">{{ "SAVE" | translate }}</button>
          </div>
        </div>
        <!-- skills-->
        <div class="card" id="skill-card" *ngIf="active_table === 'skill'">
          <div class="card-header">
            <h3 class="card-title">{{ "SKILLS" | translate }}</h3>
          </div>
          <div class="card-body">
            <div class="row align-items-center border-bottom-1 border-bottom mb-2 pb-1" *ngFor="let skill of items_skills; let i = index">
              <div class="col-lg-4 col-12 form-group" [ngbTooltip]="skillNotDeletable && skillNotDeletable.includes(skill.skill) && skill.enabled !== -1 ? ('SKILL_FROM_EXPERIENCE' | translate) : null">
                <label [for]="'skill_skill_' + i">{{ "NAME" | translate }}</label>
                <ng-select
                  [id]="'skill_skill_' + i"
                  bindLabel="name"
                  bindValue="id"
                  [closeOnSelect]="true"
                  [clearable]="false"
                  [openOnEnter]="false"
                  [disabled]="skillNotDeletable && skillNotDeletable.includes(skill.skill)"
                  [virtualScroll]="true"
                  [items]="_skillService.list_enabled"
                  [(ngModel)]="skill.skill"
                  *ngIf="skill.enabled == 1 || (!skill.isNew && skill.enabled !== -1)"
                  (change)="checkIfAlreadyInsertedSkill($event, i)"
                  [readonly]="!_authenticationService.hasCapability('edit_other_user') && !this.is_my_profile"
                >
                </ng-select>
                <ng-select
                  [id]="'skill_' + i"
                  bindLabel="name"
                  bindValue="id"
                  [closeOnSelect]="true"
                  [clearable]="false"
                  [openOnEnter]="false"
                  [virtualScroll]="true"
                  *ngIf="skill.enabled === -1"
                  [(ngModel)]="skill.skill"
                  [items]="_skillService.list"
                  [readonly]="true"
                  [ngbTooltip]="'TO_APPROVED' | translate"
                >
                </ng-select>
                <input type="text" class="form-control" [value]="skill.skill" *ngIf="skill.isNew && skill.enabled !== 1" readonly />
              </div>
              <div class="col-lg-4 col-12 form-group">
                <label [for]="'skill_level_' + i">{{ "LEVEL" | translate }}</label>
                <ng-select
                  bindValue="value"
                  bindLabel="label"
                  [id]="'skill_level_' + i"
                  [items]="skill_levels"
                  [(ngModel)]="skill.level"
                  [closeOnSelect]="true"
                  [clearable]="false"
                  [openOnEnter]="false"
                  [virtualScroll]="true"
                  [readonly]="!_authenticationService.hasCapability('edit_other_user') && !this.is_my_profile"
                ></ng-select>
              </div>
              <div class="col-lg-4 col-xl-3 col-12 form-group text-lg-center">
                <div class="custom-control custom-control-success custom-switch mt-2">
                  <span class="mr-2">{{ "SET_AS_PRIMARY_SKILL" | translate }}</span>
                  <input
                    type="checkbox"
                    checked
                    class="custom-control-input"
                    (change)="onSetPrimarySkill(skill, i)"
                    [disabled]="skill.level === '' || skill.skill < 1"
                    [id]="'skill_primary_' + i"
                    [(ngModel)]="skill.primary"
                    [readonly]="!_authenticationService.hasCapability('edit_other_user') && !this.is_my_profile"
                  />
                  <label class="custom-control-label" [for]="'skill_primary_' + i"></label>
                </div>
              </div>
              <div class="col-xl-1 col-12 text-right">
                <button
                  *ngIf="(items_skills.length > 1 && _authenticationService.hasCapability('edit_other_user')) || is_my_profile"
                  class="btn btn-icon btn-danger"
                  type="button"
                  (click)="removeSkillItem(i)"
                  rippleEffect
                  [disabled]="(skillNotDeletable && skillNotDeletable.includes(skill.skill)) || skill.enabled == -1"
                >
                  <span>{{ "REMOVE" | translate }}</span>
                </button>
              </div>
              <div class="form-group col-12" *ngIf="skill.skill === 0">
                <p class="sugges-new-item" (click)="modalOpen(modalAddSkill, i)">{{ "MODAL.NOT_SKILL" | translate }}</p>
              </div>
            </div>

            <button *ngIf="_authenticationService.hasCapability('edit_other_user') || is_my_profile" class="btn btn-icon btn-secondary" type="button" (click)="addSkillItem()" rippleEffect>
              <i [data-feather]="'plus'" class="mr-25"></i>
              <span>{{ "ADD_NEW" | translate }}</span>
            </button>
          </div>
          <div class="card-footer" *ngIf="_authenticationService.hasCapability('edit_other_user') || is_my_profile">
            <button type="submit" class="btn btn-primary" (click)="save()">{{ "SAVE" | translate }}</button>
          </div>
        </div>
        <!-- lingue-->
        <div class="card" *ngIf="active_table === 'language'">
          <div class="card-header">
            <h3 class="card-title">{{ "LANGUAGES" | translate }}</h3>
          </div>
          <div class="card-body">
            <div class="row align-items-center border-bottom-1 border-bottom mb-2 pb-1" *ngFor="let lang of items_languages; let i = index">
              <div class="col-lg-4 col-xl-3 col-12 form-group">
                <label [for]="'language_name_' + i">{{ "NAME" | translate }}</label>
                <ng-select
                  bindValue="id"
                  bindLabel="name"
                  [id]="'language_name_' + i"
                  [(ngModel)]="lang.name"
                  [items]="languages_list"
                  [closeOnSelect]="true"
                  [clearable]="false"
                  [openOnEnter]="false"
                  [virtualScroll]="true"
                  [readonly]="!_authenticationService.hasCapability('edit_other_user') && !this.is_my_profile"
                ></ng-select>
              </div>
              <div class="col-lg-4 col-12 form-group">
                <label [for]="'language_speak_' + i">{{ "LEVEL_SPEAK" | translate }}</label>
                <ng-select
                  [id]="'language_speak_' + i"
                  [(ngModel)]="lang.speak"
                  [searchable]="false"
                  [closeOnSelect]="true"
                  [clearable]="false"
                  [openOnEnter]="false"
                  [virtualScroll]="true"
                  [readonly]="!_authenticationService.hasCapability('edit_other_user') && !this.is_my_profile"
                >
                  <ng-template ng-label-tmp let-item="item" *ngIf="lang.speak">
                    <span>{{ item }} - {{ "LANGUAGE_LEVELS." + item + ".LABEL" | translate }}</span>
                  </ng-template>
                  <ng-option *ngFor="let level of language_levels" [value]="level">
                    <strong>{{ level }} - {{ "LANGUAGE_LEVELS." + level + ".LABEL" | translate }}</strong>
                    <p class="white-space-break">{{ "LANGUAGE_LEVELS." + level + ".DESCRIPTION" | translate }}</p>
                  </ng-option>
                </ng-select>
              </div>
              <div class="col-lg-4 col-12 form-group">
                <label [for]="'language_write_' + i">{{ "LEVEL_WRITE" | translate }}</label>
                <ng-select
                  [id]="'language_speak_' + i"
                  [(ngModel)]="lang.write"
                  [searchable]="false"
                  [closeOnSelect]="true"
                  [clearable]="false"
                  [openOnEnter]="false"
                  [virtualScroll]="true"
                  [readonly]="!_authenticationService.hasCapability('edit_other_user') && !this.is_my_profile"
                >
                  <ng-template ng-label-tmp let-item="item" *ngIf="lang.write">
                    <span>{{ item }} - {{ "LANGUAGE_LEVELS." + item + ".LABEL" | translate }}</span>
                  </ng-template>
                  <ng-option *ngFor="let level of language_levels" [value]="level">
                    <strong>{{ level }} - {{ "LANGUAGE_LEVELS." + level + ".LABEL" | translate }}</strong>
                    <p class="white-space-break">{{ "LANGUAGE_LEVELS." + level + ".DESCRIPTION" | translate }}</p>
                  </ng-option>
                </ng-select>
              </div>
              <div class="col-xl-1 text-right">
                <button *ngIf="_authenticationService.hasCapability('edit_other_user') || is_my_profile" class="btn btn-icon btn-danger" type="button" (click)="removeLanguageItem(i)" rippleEffect>
                  <span>{{ "REMOVE" | translate }}</span>
                </button>
              </div>
            </div>
            <button *ngIf="_authenticationService.hasCapability('edit_other_user') || is_my_profile" class="btn btn-icon btn-secondary" type="button" (click)="addLanguageItem()" rippleEffect>
              <i [data-feather]="'plus'" class="mr-25"></i>
              <span>{{ "ADD_NEW" | translate }}</span>
            </button>
          </div>
          <div class="card-footer">
            <button *ngIf="_authenticationService.hasCapability('edit_other_user') || is_my_profile" type="submit" class="btn btn-primary" (click)="save()">{{ "SAVE" | translate }}</button>
          </div>
        </div>
        <!-- formazione-->
        <div class="card" id="education-card" *ngIf="active_table === 'education'">
          <div class="card-body">
            <h3>{{ "EDUCATION" | translate }}</h3>
            <div class="row align-items-center" *ngFor="let education of items_education; let i = index">
              <div class="form-group col-lg-3 col-12">
                <label [for]="'education_title_' + i">{{ "EDUCATION_TITLE" | translate }}<sup class="text-danger">*</sup></label>
                <ng-select
                  [id]="'education_title_' + i"
                  [(ngModel)]="education.title_id"
                  bindLabel="name"
                  bindValue="id"
                  [searchable]="true"
                  [closeOnSelect]="true"
                  [clearable]="false"
                  (change)="education.subject = ''; education.name = $event.name"
                  [items]="_educationTitleService.list"
                  [openOnEnter]="false"
                  [virtualScroll]="true"
                  [readonly]="!_authenticationService.hasCapability('edit_other_user') && !this.is_my_profile"
                >
                  <div class="invalid-feedback">{{ "ERRORS.INSERT_EDUCATION_TITLE" | translate }}</div>
                </ng-select>
              </div>
              <div class="form-group col-lg-3 col-12">
                <label *ngIf="education.name === 'Laurea'" [for]="'education_subject_' + i">{{ "SCHOOL" | translate }} <sup class="text-danger">*</sup></label>
                <label *ngIf="education.name !== 'Laurea'" [for]="'education_subject_' + i">{{ "COURSE_STUDY" | translate }}<sup class="text-danger">*</sup></label>
                <input
                  *ngIf="education.name !== 'Laurea'"
                  type="text"
                  [id]="'education_subject_' + i"
                  class="form-control"
                  [(ngModel)]="education.subject"
                  [readonly]="!_authenticationService.hasCapability('edit_other_user') && !this.is_my_profile"
                />
                <ng-select
                  *ngIf="education.name === 'Laurea'"
                  bindValue="id"
                  bindLabel="name"
                  [id]="'education_title1_' + i"
                  [(ngModel)]="education.subject"
                  [items]="_educationSubjectService.list"
                  [closeOnSelect]="true"
                  [clearable]="false"
                  [openOnEnter]="false"
                  [virtualScroll]="true"
                  [readonly]="!_authenticationService.hasCapability('edit_other_user') && !this.is_my_profile"
                >
                </ng-select>
                <div *ngIf="education.name !== 'Laurea'" class="invalid-feedback">{{ "ERRORS.INSERT_EDUCATION_SCHOOL" | translate }}</div>
                <div *ngIf="education.name == 'Laurea'" class="invalid-feedback">{{ "ERRORS.INSERT_EDUCATION_COURSE" | translate }}</div>
              </div>
              <div class="form-group col-lg-1 col-12">
                <div>
                  <label [for]="'education_vote_' + i">{{ "EDUCATION_VOTE" | translate }}</label>
                  <input
                    *ngIf="!education.current"
                    type="text"
                    [id]="'education_vote_' + i"
                    class="form-control"
                    [(ngModel)]="education.vote"
                    [readonly]="!_authenticationService.hasCapability('edit_other_user') && !this.is_my_profile"
                  />
                  <input *ngIf="education.current" type="text" [id]="'education_vote2_' + i" class="form-control" [(ngModel)]="education.vote" readonly />
                </div>
              </div>
              <div class="form-group col-lg-2 col-12 d-flex align-items-center mt-2">
                <div class="custom-control custom-control-primary custom-switch mr-075">
                  <input
                    (change)="cancelVote(i)"
                    type="checkbox"
                    class="custom-control-input"
                    [id]="'education_current_' + i"
                    [(ngModel)]="education.current"
                    [readonly]="!_authenticationService.hasCapability('edit_other_user') && !this.is_my_profile"
                  />
                  <label class="custom-control-label" [for]="'education_current_' + i"> </label>
                </div>
                <small>{{ "ON_STUDING" | translate }}</small>
              </div>
              <div class="form-group col-lg-2 col-12 d-flex align-items-center mt-2">
                <div class="custom-control custom-control-primary custom-switch mr-075">
                  <input
                    (change)="onSetPrimaryEducation(education, i)"
                    type="checkbox"
                    class="custom-control-input"
                    [id]="'education_primary_' + i"
                    [(ngModel)]="education.primary"
                    [readonly]="!_authenticationService.hasCapability('edit_other_user') && !this.is_my_profile"
                  />
                  <label class="custom-control-label" [for]="'education_primary_' + i"> </label>
                </div>
                <small>{{ "PRIMARY_EDUCATION" | translate }}</small>
              </div>
              <div class="col-xl-1 text-right">
                <button
                  *ngIf="(items_certifications.length > 1 && _authenticationService.hasCapability('edit_other_user')) || is_my_profile || is_my_profile"
                  class="btn btn-icon btn-danger"
                  type="button"
                  (click)="removeEducationItem(i)"
                  rippleEffect
                >
                  <span>{{ "REMOVE" | translate }}</span>
                </button>
              </div>
            </div>
            <div class="row mb-2 border-bottom">
              <div class="col-12">
                <button *ngIf="_authenticationService.hasCapability('edit_other_user') || is_my_profile" class="btn btn-icon btn-secondary mt-1 mb-2" type="button" (click)="addEducationItem()" rippleEffect>
                  <i [data-feather]="'plus'" class="mr-25"></i>
                  <span>{{ "ADD_NEW" | translate }}</span>
                </button>
              </div>
            </div>

            <h3 class="mt-1">{{ "CERTIFICATIONS" | translate }}</h3>
            <div class="row align-items-center" *ngFor="let cert of items_certifications; let i = index">
              <div class="col-lg-11 col-12 form-group">
                <label [for]="'cert_certID_' + i">{{ "NAME" | translate }}</label>
                <ng-select
                  bindValue="id"
                  bindLabel="name"
                  [id]="'cert_certID_' + i"
                  [(ngModel)]="cert.cert_id"
                  [items]="_certificationService.list_enabled"
                  *ngIf="!cert.isNew"
                  [closeOnSelect]="true"
                  [clearable]="false"
                  [openOnEnter]="false"
                  [virtualScroll]="true"
                  [readonly]="!_authenticationService.hasCapability('edit_other_user') && !this.is_my_profile"
                ></ng-select>
                <input type="text" class="form-control" [value]="cert.cert_id" *ngIf="cert.isNew" readonly />
              </div>
              <div class="col-xl-1 text-right">
                <button
                  *ngIf="(items_certifications.length > 1 && _authenticationService.hasCapability('edit_other_user')) || is_my_profile || is_my_profile"
                  class="btn btn-icon btn-danger"
                  type="button"
                  (click)="removeCertificationItem(i)"
                  rippleEffect
                >
                  <span>{{ "REMOVE" | translate }}</span>
                </button>
              </div>
              <div class="form-group col-12" *ngIf="cert.cert_id === 0">
                <p class="sugges-new-item" (click)="modalOpen(modalAddNewCertifications, i)">{{ "MODAL.NOT_CERTIFICATE" | translate }}</p>
              </div>
            </div>
            <button *ngIf="_authenticationService.hasCapability('edit_other_user') || is_my_profile" class="btn btn-icon btn-secondary" type="button" (click)="addCertificationItem()" rippleEffect>
              <i [data-feather]="'plus'" class="mr-25"></i>
              <span>{{ "ADD_NEW" | translate }}</span>
            </button>
          </div>
          <div class="card-footer" *ngIf="_authenticationService.hasCapability('edit_other_user') || is_my_profile">
            <button type="submit" class="btn btn-primary" (click)="save()">{{ "SAVE" | translate }}</button>
          </div>
        </div>
      </div>
    </section>
  </div>
</div>

<!-- Modal New Skill -->
<ng-template #modalAddSkill let-modal>
  <form (ngSubmit)="addModalObjectSkill(); modal.close()">
    <div class="modal-header">
      <div></div>
      <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body" tabindex="0">
      <h3>{{ "MODAL.NOT_SKILL" | translate }}</h3>
      <p>{{ "MODAL.INSERT_HERE" | translate }}</p>
      <label [for]="'new_skill'">{{ "SKILLS" | translate }}<sup class="text-danger">*</sup></label>
      <input name="new_skill" [(ngModel)]="new_skill" type="text" [id]="'new_skill'" class="form-control" />
    </div>
    <div class="modal-footer d-flex justify-content-center">
      <button type="submit" class="btn btn-primary w-150" rippleEffect>
        {{ "SEND" | translate }}
      </button>
    </div>
  </form>
</ng-template>
<!-- / Modal New Skill -->

<!-- Modal New Certifications-->
<ng-template #modalAddNewCertifications let-modal>
  <form (ngSubmit)="addModalObjectCertification(); modal.close()">
    <div class="modal-header">
      <div></div>
      <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body" tabindex="0">
      <h3>{{ "MODAL.NOT_CERTIFICATE" | translate }}</h3>
      <p>{{ "MODAL.INSERT_HERE" | translate }}</p>
      <label [for]="'new_certificate'">{{ "CERTIFICATE" | translate }}</label>
      <input name="new_certificate" [(ngModel)]="new_certificate" type="text" [id]="new_certificate" class="form-control" />
    </div>
    <div class="modal-footer d-flex justify-content-center">
      <button type="submit" class="btn btn-primary w-150" rippleEffect>
        {{ "SEND" | translate }}
      </button>
    </div>
  </form>
</ng-template>
<!-- / Modal New Certifications -->

<!-- Modal New Skill to propose form tecnology -->
<ng-template #modalToProposeSkill let-modal>
  <form (ngSubmit)="addSkillToPropose(); modal.close()">
    <div class="modal-header">
      <div></div>
      <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body" tabindex="0">
      <h3>{{ "MODAL.NOT_SKILL_CANDIDATE" | translate }}</h3>
      <p>{{ "MODAL.INSERT_HERE" | translate }}</p>
      <label [for]="'new_skill'">{{ "SKILLS" | translate }}<sup class="text-danger">*</sup></label>
      <input name="new_skill" [(ngModel)]="new_skill" type="text" [id]="'new_skill'" class="form-control" />
    </div>
    <div class="modal-footer d-flex justify-content-center">
      <button type="submit" class="btn btn-primary w-150" rippleEffect>{{ "SEND" | translate }}</button>
    </div>
  </form>
</ng-template>
<!-- / Modal New Skill -->
